// @core/api/endpoints/form/delete_form.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/form';

/**
 * Delete form
 * Deletes a form and all its fields, submissions, and associated data.
 */
export async function DeleteForm(
  form_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/forms/:form_id`;
  requestPath = requestPath.replace(':form_id', encodeURIComponent(form_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
